module.exports = __webpack_public_path__ + "img/biwaho_mo.85b60a57.jpg";